export default function FormatMilliseconds(value: number)
{
  let seconds = Math.floor(value / 1000)
  const minutes = Math.floor(seconds / 60)
  seconds = seconds % 60

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}
